import TripMatchSidebarContainer from './trip-sidebar-container';

export default TripMatchSidebarContainer;
